<template>
  <v-container>
    <v-card dark color="primary">
      <v-card-title class="headline primary">Search for organization users</v-card-title>
      <v-card-text>Search for organization users to add it to group.</v-card-text>
      <v-card-text>
        <v-autocomplete
          v-model="selected"
          :items="organizationUsers"
          :filter="customFilter"
          color="white"
          item-text="first_name"
          item-value="uuid"
          label="User"
          hide-selected
          return-object
          :multiple="false"
          class
        >
          <template v-slot:item="data">
            <v-list-item-icon>
              <v-icon>face</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.first_name + ' ' + data.item.last_name"></v-list-item-title>
              <v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-slot:selection="data">{{data.item.first_name + ' ' + data.item.last_name}}</template>
          <template v-slot:append-outer>
            <v-btn color="success" @click="addUserToGroup()">
              <v-icon left>add</v-icon>
              <span>Add</span>
            </v-btn>
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
    <GroupUsersTable
      class="mt-5"
      :headers="headers"
      :data="groupUsers"
      :isLoading="isUsersLoading"
      v-on:refresh="refresh"
      v-on:removeOne="removeOne"
    />
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import GroupUsersTable from "@/components/Access/Groups/GroupUsersTable";

export default {
  mixins: [mixin],
  components: {
    GroupUsersTable
  },
  props: {
    group: { type: Object, required: true }
  },
  data() {
    return {
      groupUuid: null,
      groupUsers: [],
      selected: null,
      snackbar: false,
      errorMessage: "",
      headers: [
        {
          text: "First Name",
          align: "start",
          filterable: true,
          value: "first_name",
          width: "20%"
        },
        {
          text: "Last Name",
          align: "start",
          filterable: true,
          value: "last_name",
          width: "20%"
        },
        {
          text: "Email",
          align: "start",
          filterable: true,
          value: "email",
          width: "30%"
        },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ]
    };
  },
  computed: {
    ...mapState({
      currentOrganization: state => state.organizations.current,
      isUsersLoading: state =>
        state.organizations.fetchOrganizationGroupUsers.pending,
      isUsersError: state =>
        state.organizations.fetchOrganizationGroupUsers.error,
      organizationUsers: state => state.organizations.users
    })
  },
  watch: {
    group() {
      if (this.group.uuid) {
        this.groupUuid = this.group.uuid;
        this.refresh();
      }
    }
  },
  methods: {
    ...mapActions("organizations", {
      fetchOrganizationGroupUsers: "fetchOrganizationGroupUsers",
      fetchAllUsers: "fetchAllUsers",
      addUserToOrganizationGroup: "addUserToOrganizationGroup",
      removeUserFromOrganizationGroup: "removeUserFromOrganizationGroup"
    }),
    refresh() {
      this.fetchOrganizationGroupUsers({
        organizationUuid: this.currentOrganization.uuid,
        groupUuid: this.groupUuid
      }).then(users => {
        this.groupUsers = users;
      });
      this.fetchAllUsers({
        organizationUuid: this.currentOrganization.uuid
      }).catch(error => {
        this.snackbar = true;
        this.errorMessage = this.errorDisplay(error);
      });
    },
    customFilter(item, queryText) {
      const textOne = item.first_name.toLowerCase();
      const textTwo = item.last_name.toLowerCase();
      const textThree = item.email.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1 || textThree.indexOf(searchText) > -1
      );
    },
    addUserToGroup() {
      if (this.selected) {
        this.addUserToOrganizationGroup({
          organizationUuid: this.currentOrganization.uuid,
          groupUuid: this.groupUuid,
          userUuid: this.selected.uuid
        })
          .then(() => {
            this.refresh();
          })
          .catch(error => {
            this.snackbar = true;
            this.errorMessage = this.errorDisplay(error);
          });
      }
    },
    removeOne(user) {
      this.removeUserFromOrganizationGroup({
        organizationUuid: this.currentOrganization.uuid,
        groupUuid: this.groupUuid,
        userUuid: user.uuid
      })
        .then(() => {
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  }
};
</script>

<style>
</style>